import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/commonTypes';

import {stateStructure} from './_stateStructure.js'

const initialState = Immutable.fromJS( stateStructure.common );

export default function common( state = initialState, action ){

	let _state = state.toJS();

	switch (action.type) {
		// 获取公告列表
		case ACTION.GET_BULLETINS:{
			_state.bulletins.count = action.result.data.count;
			_state.bulletins.list = action.result.data.list.map((item) => _.merge(item, {type:1}));
			return state.merge(_state);
		}
		// 获取系统设置，常量
		case ACTION.GET_WEB_SETTINGS:{
			window.webSettings = action.result.data;
			_state.settings = action.result.data;
			return state.merge(_state);
		}
		// 获取banner列表
		case ACTION.GET_BANNERS:{
			_state.banners = action.result.data;
			return state.merge(_state);
		}
		// 获取中奖人名单
		case ACTION.GET_WINNERS:{
			_state.winners = action.result.data;
			return state.merge(_state);
		}
		// 获取新验证码
		case ACTION.GET_VALIDCODE:{
			_state.captcha = action.result.data;
			return state.merge(_state);
		}
		// 获取公告详情
		case ACTION.GET_BULLETIN_DETAIL:{
			const newBulletins = _.map(_state.bulletins.list, (item) => item.id === action.result.data.id ? _.merge(item, {content: _.replace(action.result.data.content, /(<br>|<br\/>)/g, '')}) : item)
			_state.bulletins.list = newBulletins;
			return state.merge(_state);
		}

		// 关闭右下角中间滚动信息
		case ACTION.CLOSE_WINNER_NOTICE:{
			_state.showWinner = false;
			return state.merge(_state);
		}

		// 打开关闭验证码输入框状态
		case ACTION.TOGGLE_VAILDCODE:{
			_state.showCaptcha = action.status;
			return state.merge(_state);
		}

		//标示域名验证是否验证成功
		case ACTION.MARK_DOMAIN_STATUS:{
			_state.checkDomainResult = {
				status: action.status,
				domain: action.domain
			}
			return state.merge(_state);
		}

		//登录页清楚域名验证数据
		case ACTION.CLEAR_DOMAIN_STATUS:{
			_state.checkDomainResult = {}
			return state.merge(_state);
		}

		//获取域名测速列表
		case ACTION.GET_SPEED_DOMAINS:{
			_state.speedDomains = _.concat(..._.chain(action.result.data).map((item, key) => _.map(item, function(it, k){return {domain: it, key:key}})).value()).map((item, index) => _.merge(item, {index: _.padStart(index + 1, 2, '0')}));
			return state.merge(_state);
		}

		// 获取站内信
		case ACTION.GET_MESSAGES:{
			_state.messages = action.result.data;
			return state.merge(_state);
		}
		// 获取站内信详情
		case ACTION.GET_MESSAGES_DETAIL:{
			const { id, content } = action.result.data;
			var trasfer = function(content) {
				try {
					return JSON.parse(content)
				}catch(e){
					return  content
				}
			}
			_state.messages.list = _.map(_state.messages.list, (message) => message.id == id ? _.merge({content: trasfer(content)}, message) : message);
			return state.merge(_state);
		}
		// 删除站内信
		case ACTION.DELETE_MESSAGES:{
			_state.messages.list = _.filter(_state.messages.list, (message) => message.id != action.extend)
			return state.merge(_state)
		}
		// 获取收藏列表
		case ACTION.FAVORITES_LIST:{
			_state.favorites[action.extend] = action.result.data;
			return state.merge(_state)
		}
		// 添加收藏
		case ACTION.FAVORITES_CREATE:{
			const newFavorites = _.chain(action.extend.collection).map((item, index) => ({
				id: String(action.result.data.id[index]),
				target_id: String(item.target_id),
				title: item.title || ''
			})).value()
			_state.favorites['lottery'] = _.concat(_state.favorites['lottery'], newFavorites);
			return state.merge(_state)
		}
		// 删除收藏
		case ACTION.FAVORITES_DELETE:{
			_state.favorites['lottery'] = _.filter(_state.favorites['lottery'], (item) => !_.includes(action.extend.id, item.id));
			return state.merge(_state)
		}
		// 注销用户
		case USER_ACTION.LOGOUT:{
			// 保持系统设置
			const keepContextSettings = _state.settings;
			_state = initialState.toJS();
			_state.settings = keepContextSettings;
			return state.merge(_state);
		}
		default:
      		return state;
	}
}
